export class AppConfig {
    public static API_BASE_URL_DEV: string = "http://license.zanini-esc.com:8080/clever/";
    public static API_BASE_URL_PROD: string = "https://license.zanini-esc.com/api/clever/";
}